export default "__VITE_ASSET__9265aa77__"